async function initCart() {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        cache: false,
        dataType: 'json',
        success: async function(cart) {
            // Bold Product Options runs in Hybrid mode on this store: priced add-ons
            // are stored as line-item properties on the main product, NOT as separate
            // Shopify line items. Raw /cart.js therefore reports only the base price.
            // Bold's cartDoctor rewrites the cart totals/line prices to include the
            // options — this is exactly what the theme's native cart does
            // (see theme.js _updateCartPopupContent). Without this call the flyout
            // shows the un-adjusted total even though checkout is correct.
            if (window.BOLD && window.BOLD.common && window.BOLD.common.cartDoctor) {
                cart = window.BOLD.common.cartDoctor.fix(cart);
            }
            $('.sk-cart-items').empty();
            let visibleItemCount = 0;
            if(cart.item_count == 0) {
                $('.sk-cart-drawer__inner').addClass('is-empty');
                $('.sk-cart-bubble').text('');
            } else {
                $('.sk-cart-drawer__inner').removeClass('is-empty');
                const itemsProcessed = await Promise.all(cart.items.map(item => {
                    return new Promise(resolve => {
                        $.ajax({
                            type: "GET",
                            url: "/products/" + item.handle + ".js",
                            cache: false,
                            dataType: 'json',
                            success: function(product) {
                                if (!product.tags.includes("OPTIONS_HIDDEN_PRODUCT")) {
                                    var original_line_price = '';
                                    if (item.original_line_price != item.final_line_price) original_line_price = '$' + (item.original_line_price / 100).toFixed(2);

                                    // Build the selected Bold options (e.g. "Grommet(s)")
                                    // the same way the /cart page does: show each line-item
                                    // property as "name: value", skipping Bold's internal
                                    // keys (those starting with "_") and any blank values.
                                    var optionsHtml = '';
                                    if (item.properties) {
                                        Object.keys(item.properties).forEach(function(name) {
                                            var value = item.properties[name];
                                            if (name.charAt(0) === '_') return;
                                            if (value === null || value === '') return;
                                            var displayValue = (typeof value === 'string' && value.indexOf('/uploads/') !== -1)
                                                ? '<a href="' + value + '">' + value.split('/').pop() + '</a>'
                                                : value;
                                            optionsHtml += '<li class="sk-cart-item__option"><span class="sk-cart-item__option-name">' + name + ':</span> ' + displayValue + '</li>';
                                        });
                                    }
                                    var optionsBlock = optionsHtml ? '<ul class="sk-cart-item__options">' + optionsHtml + '</ul>' : '';

                                    var cartItem = `
                                    <div class="sk-cart-item">
                                        <div class="sk-cart-item__img">
                                            <a href="${item.url}">
                                                <img src="${item.image}" alt="${item.product_title}">
                                            </a>
                                        </div>
                                        <div class="sk-cart-item__content" data-key="${item.key}">
                                            <a href="{{ item.product.url }}" class="sk-cart-item__title">${item.product_title}</a>
                                            ${optionsBlock}
                                            <div class="sk-cart-item__quantity">
                                                <span class="sk-qty-btn minus">-</span>
                                                <input class="sk-qty-input" value="${item.quantity}" type="number">
                                                <span class="sk-qty-btn plus">+</span>
                                            </div>
                                        </div>
                                        <div class="sk-cart-item__footer">
                                            <span class="sk-cart-item__remove" data-key="${item.key}">
                                                <img src="https://cdn.shopify.com/s/files/1/0272/6992/2952/files/trash-new_1.png?v=1689706164" alt="trash">
                                            </span>
                                            <div class="sk-cart-item__price">
                                                <span class="sk-cart-item__original-price">
                                                    ${original_line_price}
                                                </span>
                                                <span class="sk-cart-item__final-price">
                                                    $${(item.final_line_price / 100).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    `;
                                    $('.sk-cart-items').append(cartItem);
                                    visibleItemCount += item.quantity;
                                }
                                resolve();
                            }
                        });
                    });
                }));
                $('.sk-cart-bubble').text(visibleItemCount);
                $('.sk-cart-total__price').text(`$${(cart.total_price / 100).toFixed(2)}`);
            }
            // Let Bold (and any other Bold-aware widgets) know the cart was re-read,
            // mirroring the theme's native cart behavior.
            if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter &&
                typeof window.BOLD.common.eventEmitter.emit === 'function') {
                window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
        }
    });
}



function updateCart(key, quantity) {
    var updates = {};
    updates[key] = quantity
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates:updates
        },
        dataType: 'json',
        async:false,
        success: function(){initCart()}
    });
}

function openCart() {
    $('.sk-cart-drawer').addClass('active');
    $('body').css('overflow', 'hidden');
}

function closeCart() {
    $('.sk-cart-drawer').addClass('slide-right');
    setTimeout(() => {
        $('.sk-cart-drawer').removeClass('slide-right');
        $('.sk-cart-drawer').removeClass('active');
        $('body').css('overflow', 'auto');
    }, 300);
}

$(document).on('click', '.sk-cart-open', function(e){
    e.preventDefault();
    openCart();
});

$(document).on('click', '.sk-cart-close', function(e){
    e.preventDefault();
    closeCart();
});

$(document).on('click', '.sk-cart-drawer', function(e){
    closeCart();
});

$(document).on('click', '.sk-cart-drawer__inner', function(e){
    e.stopPropagation();
});

$(document).on('click', '.sk-qty-btn', function(e){
    e.preventDefault();
    let $content = $(this).closest('.sk-cart-item__content');
    let quantity = Number($content.find('.sk-qty-input').val());
    let key = $content.data('key');
    if($(this).hasClass('minus')) {
        if (quantity > 1) {
            quantity -= 1;
        }
    } else {
        quantity += 1;
    }
    $content.find('.sk-qty-input').val(quantity);
    updateCart(key, quantity);
});

$(document).on('change', '.sk-qty-input', function(e){
    e.preventDefault();
    let $content = $(this).closest('.sk-cart-item__content');
    let quantity = $content.find('.sk-qty-input').val();
    let key = $content.data('key');
    updateCart(key, quantity);
});

$(document).on('click', '.sk-cart-item__remove', function(e){
    e.preventDefault();
    let key = $(this).data('key');
    updateCart(key, 0);
});

$(document).on('submit', '[action="/cart/add"]', function(e){
    e.preventDefault();
    var data = $(this).serialize();
    var actionUrl = $(this).attr('action');
    $.ajax({
        type: "POST",
        url: actionUrl,
        data: data,
        success: function(cart)
        {
            initCart();
            openCart();
        }
    });
});

initCart();